export default __webpack_public_path__ + "static/media/birds-bottom.fd7a9f8e.svg";